/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsBoolResponse,
    ControlcenterMelcoModelsBoolResponseFromJSON,
    ControlcenterMelcoModelsBoolResponseToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItem,
    ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItemToJSON,
    ControlcenterMelcoModelsProcessPayment,
    ControlcenterMelcoModelsProcessPaymentFromJSON,
    ControlcenterMelcoModelsProcessPaymentToJSON,
} from '../models';

export interface PaymentsApiPaymentsManualProcessRequest {
    id: string;
    controlcenterMelcoModelsProcessPayment?: ControlcenterMelcoModelsProcessPayment;
}

export interface PaymentsApiPaymentsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    productList?: string;
    userName?: string;
    serviceStartDate?: Date;
    serviceEndDate?: Date;
    statusList?: string;
    melcoCustomerId?: string;
    transactionDate?: Date;
    affiliateList?: string;
    paymentMode?: string;
    orgUnit?: string;
}

/**
 * 
 */
export class PaymentsApi extends runtime.BaseAPI {

    /**
     */
    async paymentsManualProcessRaw(requestParameters: PaymentsApiPaymentsManualProcessRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsBoolResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling paymentsManualProcess.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/payments/{id}/manual_process`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsProcessPaymentToJSON(requestParameters.controlcenterMelcoModelsProcessPayment),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async paymentsManualProcess(requestParameters: PaymentsApiPaymentsManualProcessRequest): Promise<ControlcenterMelcoModelsBoolResponse> {
        const response = await this.paymentsManualProcessRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentsSearchRaw(requestParameters: PaymentsApiPaymentsSearchRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        if (requestParameters.userName !== undefined) {
            queryParameters['user_name'] = requestParameters.userName;
        }

        if (requestParameters.serviceStartDate !== undefined) {
            queryParameters['service_start_date'] = (requestParameters.serviceStartDate as any).toISOString();
        }

        if (requestParameters.serviceEndDate !== undefined) {
            queryParameters['service_end_date'] = (requestParameters.serviceEndDate as any).toISOString();
        }

        if (requestParameters.statusList !== undefined) {
            queryParameters['status_list'] = requestParameters.statusList;
        }

        if (requestParameters.melcoCustomerId !== undefined) {
            queryParameters['melco_customer_id'] = requestParameters.melcoCustomerId;
        }

        if (requestParameters.transactionDate !== undefined) {
            queryParameters['transaction_date'] = (requestParameters.transactionDate as any).toISOString();
        }

        if (requestParameters.affiliateList !== undefined) {
            queryParameters['affiliate_list'] = requestParameters.affiliateList;
        }

        if (requestParameters.paymentMode !== undefined) {
            queryParameters['payment_mode'] = requestParameters.paymentMode;
        }

        if (requestParameters.orgUnit !== undefined) {
            queryParameters['org_unit'] = requestParameters.orgUnit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/payments/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSON(jsonValue));
    }

    /**
     */
    async paymentsSearch(requestParameters: PaymentsApiPaymentsSearchRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsPaymentListItem> {
        const response = await this.paymentsSearchRaw(requestParameters);
        return await response.value();
    }

}
